exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ArchetypeDetail{padding-top:1rem}.ArchetypeDetail>*{background:#eee;padding:4px 8px;border-radius:4px}.ArchetypeDetail .elements{font-size:small;clear:both;margin-top:1rem}.ArchetypeDetail .elements .center-col{padding:0px}.ArchetypeDetail .elements td,.ArchetypeDetail .elements th{padding:0 15px}.ArchetypeDetail h5{margin-top:0}@media all and (max-width: 799px){.ArchetypeDetail .archetypeBlurb,.ArchetypeDetail .design-specs{float:none;width:auto}}\n", ""]);

// exports
